import axios from 'axios';

// URL de base - ajustez selon votre configuration
const API_URL = process.env.REACT_APP_API_URL || '/';

// Configuration axios globale
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur pour ajouter le token aux requêtes
api.interceptors.request.use(
  (config) => {
    // Ajouter le token client s'il existe
    const clientToken = localStorage.getItem('clientToken');
    if (clientToken) {
      config.headers['Authorization'] = `Bearer ${clientToken}`;
    }
    
    // Ajouter le token admin s'il existe (pour compatibilité)
    const adminToken = localStorage.getItem('token');
    if (adminToken && !clientToken) {
      config.headers['Authorization'] = `Bearer ${adminToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      const isClientRoute = error.config?.url?.includes('/api/client/');
      
      if (isClientRoute) {
        localStorage.removeItem('clientToken');
        localStorage.removeItem('clientData');
        localStorage.removeItem('clientPoints');
        // Redirection vers login client
        if (window.location.pathname !== '/login-client') {
          window.location.href = '/login-client';
        }
      } else {
        localStorage.removeItem('token');
        // Redirection vers login admin
        if (window.location.pathname !== '/Login') {
          window.location.href = '/Login';
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;